import { createFileRoute } from '@tanstack/react-router'

import { PageLayout } from '@/components/layout'

import { productApi } from '@/features/product/api/product-api'
import { ProductForm } from '@/features/product/components/product-form'

export const Route = createFileRoute('/_app/product/$id/update')({
  loader: async ({ context, params }) => {
    const { id } = params
    const {
      data: { product },
    } = await context.qc.ensureQueryData(productApi.detail.query({ params: { id } }))

    return {
      crumb: product.name,
    }
  },
  component: Component,
})

function Component() {
  const navigate = Route.useNavigate()
  const { id } = Route.useParams()

  return (
    <PageLayout>
      <ProductForm
        mode='update'
        id={id}
        onBack={() => navigate({ to: '/product', replace: true })}
      />
    </PageLayout>
  )
}
